module.exports = __webpack_public_path__ + "img/mitz_yes.12b3997a.png";